<template>
    <div class="pay_success full">
        <div class="box1">
            <img :src="$store.state.api.imgUrl + 'success_icon1.png'" alt="">
            <p>购买成功！感谢您的购买</p>
            <div class="go_detail" @click="go_detail">查看订单详情</div>
        </div>
        <div class="margin"></div>
        <!-- <div class="box2">
            <img :src="$store.state.api.imgUrl + 'success_icon2.png'" alt="">
            <div class="bot" @click="kf">联系客服</div>
        </div> -->

        <!--<div class="wechat">
            <p class="p1">微信关注公众号“微量精准检验”<br/>报告自动推送</p>           
            <p class="p2" v-text="orderNo? '（长按识别二维码关注公众号）' : '（保存至微信，识别二维码关注公众号）'"></p>
            <img :src="$store.state.api.imgUrl + 'peath_qrcode.png'" alt="">
            <p class="p3">扫码关注，报告自动推送</p>
        </div>-->
        <div class="wechatBox">
        	<div class="wechatMain">
        		<div class="wechatPic"><img :src="$store.state.api.imgUrl + 'wechatPic.jpg'" alt=""></div>
        	
        	    <div class="wechatTxt">
        		   <div class="txtTop"> 
        			   <div class="txtTopL"><img :src="$store.state.api.imgUrl + 'wechatIcon.png'" alt=""></div>
        			   <div class="txtTopR">
        				<p>微信关注公众号</p>
        				<p>报告自动推送</p>
        			   </div>
        			   </div>
        			   <div class="txtBot">
        					<span class="txtBotpic"><img :src="$store.state.api.imgUrl + 'seachIcon.png'"></span>
        					<span class="txtBottxt">微量精准检验</span>        				
        			   </div>
        		
        	</div>
          </div>
        </div>
        
    </div>
</template>
<style lang="scss" scoped>
    .pay_success{
        width: 100%;
        display: flex;
        flex-direction: column; 
        align-items: center;
        position: relative;
        overflow-y: hidden;
        background-color: #ffffff;

       .margin{
            height: 1%;
            width: 100%;
            background-color: #f5f5f5;
        }
        .box1{
             flex-grow: 1;
            width: 100%;
            min-height: 183px;
            margin-bottom: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
                width: 35px;
                height: 35px;
                margin-bottom: 24px;
            }
            p{
                font-family: SourceHanSansCN-Light;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #0690db;
            }
            .go_detail{
                width: 125px;
                height: 25px;
                background-color: #0690db;
                border-radius: 3px;
                font-family: SourceHanSansCN-Light;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ffffff;
                margin-top: 18px;
                line-height: 27px;
            }
        }
        .box2{
            padding-top: 17px;
            box-sizing: border-box;
            height: 74.5%;
            position: relative;
            img{
                width: 375px;
                height: 166px;
            }
            
        }
        .wechat{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;
            flex: 1;
            padding-top: 36px;
            img{
                width: 180px;
                height: 180px;
                object-fit: cover;
            }
            p{
                font-family: SourceHanSansCN-Normal;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #666666;
                 margin-bottom: 10px;
            }
            .p1{
                font-family: SourceHanSansCN-Bold;
                font-size: 18px;
                margin-bottom: 10px;
                font-weight: 700;
            }
            .p3{
                margin-top: 6px;
                margin-bottom: 0;
            }
    
        }
        .bot{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background-color: #0690db;
            font-family: SourceHanSansCN-Normal;
            font-size: 12px;
            font-weight: 100;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
        }
        
        .wechatMain{width: 96%;padding: 20px;margin: 4px auto;background: #07C160;border-radius:6px;overflow: hidden;}
        .wechatPic{width: 100px;height: 100px;border-radius: 6px;background: #FFFFFF;display: inline-block;overflow: hidden;}
        .wechatPic img{max-width: 100%;}
        .wechatTxt{float: right;color: #FFFFFF;}
        .txtTop{overflow: hidden;}
        .txtTopL{width: 40px;height: 33px;display: inline-block;margin-right: 10px;}
        .txtTopL img{max-width: 100%;}
        .txtTopR{float: right;font-size: 16px;line-height: 20px;}
        .txtBot{background: #FFFFFF;padding: 4px;border-radius: 3px;margin-top: 20px;}
        .txtBotpic{width:20px;height: 20px;display: inline-block;}
        .txtBotpic img{max-width: 100%;}
        .txtBottxt{margin-left: 10px;font-size: 16px;color: #000;line-height: 20px;}
        
        
        
        
    }
</style>
<script>
    export default {
        data(){
            return {

            }
        },
        name: 'pay_success',
        props: {
            msg: String,
            path: String,
            orderNo: String
        },
        methods: {
            kf() {
                _kf();
            },
            go_detail(){
                if(!this.orderNo) return this.$toast('请回到微信操作');
                this.$router.replace({
                    name: 'index',
                    query: {
                        orderNo: this.orderNo,
                        // orderId: this.orderId,
                        orderStatus: 1,
                        target: 'orderDetail'
                    }
                })
            }
        },
    }
</script>

